mutation ResolveInlineComment($commentId: ID!, $resolved: Boolean!) {
  resolveInlineComment(commentId: $commentId, resolved: $resolved, dangling: false) {
    status
    resolveProperties {
      resolved
      resolvedTime
      resolvedUser
      resolvedByDangling
      resolvedFriendlyDate
    }
  }
}
